<template>
  <li
    :class="classes"
    role="menuitem">
    <div class="top-level-link-container">
      <router-link
        v-text="text"
        :to="path"
      />
    </div>
    <slot/>
  </li>
</template>

<script>
export default {
  name: 'NavigationItem',
  props: {
    text: String,
    path: String,
    isSubMenuItem: Boolean,
    hasSubItems: Boolean
  },
  computed: {
    classes: function () {
      const classes = [];
      classes.push('nav-item');
      if (!this.isSubMenuItem) {
        classes.push('opens-right');
        if (this.hasSubItems) classes.push('is-dropdown-submenu-parent');
        return classes;
      }
      classes.push('child', 'is-submenu-item', 'is-dropdown-submenu-item');
      return classes;
    }
  }
};
</script>
